import { render, staticRenderFns } from "./reviews-slider.vue?vue&type=template&id=46f1239b&"
import script from "./reviews-slider.vue?vue&type=script&lang=js&"
export * from "./reviews-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports